/* RepeatDayComponent.js */

"use strict";
const Renderer = require("./RepeatDayRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class RepeatDayComponent extends BaseScheduleComponent {
    constructor(scheduleComp) {
        super(Renderer, scheduleComp);
    }
    static defaultValue() {
        let now = new Date();
        return {
            type: "day",
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            every: 1,
            time: {
                hour: now.getHours(),
                minute: now.getMinutes(),
            },
            start: {
                year: now.getFullYear(),
                month: now.getMonth(),
                date: now.getDate(),
            },
        };
    }
}
module.exports = RepeatDayComponent;
